module.exports = __webpack_public_path__ + "img/referral.8775ac6d.svg";